import React from 'react';
import {HashRouter,Routes,Route} from 'react-router-dom';
import SalesPage from './pages/SalesPage';
import CheckoutPage from './pages/CheckoutPage';
import TrialQualifierPage from './pages/TrialQualifierPage';
import ScrollToTop from './common/ScrollToTop';
import BrandSpacingFix from './common/BrandSpacingFix';

function App() {
  return (
    <HashRouter>
      <ScrollToTop />
      <BrandSpacingFix />
      <div className="min-h-screen bg-white text-slate-900 font-sans antialiased selection:bg-yellow-400 selection:text-black">
        <Routes>
          <Route path="/" element={<TrialQualifierPage />} />
          <Route path="/suite" element={<TrialQualifierPage />} />
          <Route path="/legacy" element={<SalesPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
        </Routes>
      </div>
    </HashRouter>
  );
}

export default App;